export default "__VITE_ASSET__9343fc98__"